import { useState } from 'react'

export const DENSITIES = ['compact', 'default', 'large'] as const
export type Density = (typeof DENSITIES)[number]

/** Card min widths from the design's density prop. */
export const DENSITY_COL: Record<Density, string> = { compact: '168px', default: '200px', large: '240px' }

const KEY = 'library.density'

/** Card size, remembered per browser (a convenience, not shared state). */
export function useDensity() {
  const [density, setDensity] = useState<Density>(() => {
    try {
      const v = localStorage.getItem(KEY)
      return (DENSITIES as readonly string[]).includes(v ?? '') ? (v as Density) : 'default'
    } catch {
      return 'default'
    }
  })
  const choose = (d: Density) => {
    setDensity(d)
    try {
      localStorage.setItem(KEY, d)
    } catch {
      /* private mode: just this session */
    }
  }
  return [density, choose] as const
}
